import Button from '../../../components/base/Button';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();
  
  const heroContent = {
    title: 'Hukuki Danışmanlıkta Güvenilir Çözüm Ortağınız',
    subtitle: 'Isparta\'da 4+ yıllık deneyimimizle profesyonel hukuki danışmanlık hizmetleri sunuyoruz',
    content: 'Ticaret, gayrimenkul, iş hukuku ve daha birçok alanda uzman kadromuzla yanınızdayız.',
    buttonText: 'Hizmetlerimizi İnceleyin',
    imageUrl: 'https://public.readdy.ai/ai/img_res/2e71575353ba7904c31428431709d54b.jpg'
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${heroContent.imageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900/20 to-slate-800/30"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight animate-fade-in-up font-poppins">
            {heroContent.title}
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed animate-fade-in-up animation-delay-200 font-poppins font-light">
            {heroContent.subtitle}
          </p>
          
          <p className="text-lg text-white/80 mb-12 max-w-2xl mx-auto animate-fade-in-up animation-delay-400 font-poppins font-light">
            {heroContent.content}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up animation-delay-600">
            <Button 
              variant="primary" 
              size="lg"
              onClick={() => {
                const servicesSection = document.getElementById('services');
                if (servicesSection) {
                  servicesSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              {heroContent.buttonText}
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => navigate('/contact')}
            >
              İletişime Geçin
            </Button>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}
